export default __webpack_public_path__ + "static/media/allameh-univer@2x.bb77e3c2.png";